var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKakaotalkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FEE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9955 13.1992C16.7075 13.1992 10.7969 17.8215 10.7969 23.524C10.7969 27.2303 13.3002 30.4892 17.0579 32.3106C16.7904 33.3298 16.0576 36.0169 15.9132 36.5782C15.734 37.2877 16.1806 37.2797 16.4668 37.0891L21.5484 33.6714C22.3594 33.7908 23.1782 33.851 23.9982 33.8514C31.2862 33.8514 37.1969 29.2264 37.1969 23.5266C37.1969 17.8268 31.2862 13.2019 23.9982 13.2019",
    fill: "#191600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaotalkIcon);
export default __webpack_public_path__ + "static/media/kakaotalk_icon.809267a77a39b55b02ba2097819be479.svg";
export { ForwardRef as ReactComponent };